import React, { useState, useEffect } from 'react';
import { Helmet } from "react-helmet";
import { HeaderProgressTracker } from '../../Common/HeaderStepper/HeaderProgressTracker';
import * as Steps from './index';
import { saveSessionEvent } from "../../../session";
import {
  SESSION_STORAGE_CREATE_CASE,
  setSessionStorageItem,
  getSessionStorageItem,
  SELECTED_PRODUCT_FOR_SUBMIT_A_CASE,
  ADVISOR_OBJECT_KEY,
  SESSION_STORAGE_CASE_RETURN_PATH,
  ILLUSTRATION_PREFILL_DATA,
  SESSION_STORAGE_ACCOUNT_KEY
} from '../../../sessionStorage';
import './CreateCase.scss';
import { format } from 'date-fns';
import { GetFormattedNumber } from '../../Helpers/Formatters';
import { insurancePolicyTypes } from '../ABLTC/SubComponents/SelectOptions';

export default function CreateCase(props) {

  useEffect(() => {
    saveSessionEvent()
  }, [props.location])

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])

  const path = props.location ? props.location.pathname.split("/").pop() : null;
  const allFormState = getSessionStorageItem(SESSION_STORAGE_CREATE_CASE);
  const advisorObject = getSessionStorageItem(ADVISOR_OBJECT_KEY);
  const selectedProduct = getSessionStorageItem(SELECTED_PRODUCT_FOR_SUBMIT_A_CASE);
  const productObject = getSessionStorageItem(SESSION_STORAGE_CASE_RETURN_PATH);
  const isCopyCaseData = allFormState && allFormState.isCopyCaseData ? allFormState.isCopyCaseData : false;
  const accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);
  const isMSEnableABLTCCreateCaseSurvivorshipWorkflow = accountObj && accountObj.msEnableABLTCCreateCaseSurvivorshipWorkflow;
  const isMSEnablePERMCreateCaseSurvivorshipWorkflow = accountObj && accountObj.msEnablePERMCreateCaseSurvivorshipWorkflow;
  const caseReturnPath = getSessionStorageItem(SESSION_STORAGE_CASE_RETURN_PATH);
  const isDICreateCase = (caseReturnPath && caseReturnPath.includes('disability-insurance')) || (allFormState && allFormState.pages && allFormState.pages.selectProduct && allFormState.pages.selectProduct.category === "DI");
  const isMSEnableSurvivorshipWorkflow = isDICreateCase ? false : ((selectedProduct && selectedProduct.submitCaseProductKey === "PERM") ? isMSEnablePERMCreateCaseSurvivorshipWorkflow : isMSEnableABLTCCreateCaseSurvivorshipWorkflow);

  const prefill = props.location.search && props.location.search.toLowerCase().includes('prefill');

  const advisorInfo = {
    firstName: advisorObject && advisorObject.fullName.split(' ')[0],
    lastName: advisorObject && advisorObject.fullName.split(' ')[1]
  }

  let newFormState = {
    currentStep: 1,
    pages: {
      retrieveAccount: Steps.RetrieveAccount.DefaultFormState(prefill, isMSEnableSurvivorshipWorkflow),
      insuredBasicInfo: Steps.InsuredBasicInfo.DefaultFormState(prefill),
      esign: Steps.ESign.DefaultFormState(prefill, advisorInfo),
      attestation: Steps.Attestation.DefaultFormState(),
      replaceFile: Steps.ReplaceFile.DefaultFormState(prefill),
      applicationInformation: Steps.ApplicationInformation.DefaultFormState(prefill),
      yourInformation: Steps.YourInformation.DefaultFormState(prefill),
      selectProduct: Steps.SelectProduct.DefaultFormState(prefill, selectedProduct)
    },
  }

  const initialFormState = allFormState || newFormState;
  const IllustrationRequest = getSessionStorageItem(ILLUSTRATION_PREFILL_DATA);

  const getDataFromIllustration = () => {
    let updatedForm = { ...initialFormState };
    if (IllustrationRequest && IllustrationRequest.selectedCaseDetails) {
      const selectedCaseDetails = IllustrationRequest.selectedCaseDetails;
      var retrieveAccountData = updatedForm.pages.retrieveAccount;
      var replaceFileData = updatedForm.pages.replaceFile;
      var selectProductData = updatedForm.pages.selectProduct;

      retrieveAccountData.officeFa = retrieveAccountData.officeFa ? retrieveAccountData.officeFa : selectedCaseDetails.faOfficeNumberInput + '-' + selectedCaseDetails.faidInput;
      retrieveAccountData.officeAccount = retrieveAccountData.officeAccount ? retrieveAccountData.officeAccount : selectedCaseDetails.clientBranchNumber + '-' + selectedCaseDetails.clientAccountNumber;
      retrieveAccountData.isProposedInsured = retrieveAccountData.isProposedInsured ? retrieveAccountData.isProposedInsured : (selectedCaseDetails.piIsOwner && !selectedCaseDetails.isSurvivorshipPolicyType) ? 'true' : 'false';
      const fileData = {
        fileList: [{
          dateTime: selectedCaseDetails.imageDetails.createdDate,
          extension: selectedCaseDetails.imageDetails.imageExtension,
          key: null,
          name: selectedCaseDetails.imageDetails.imageName,
        }],
        key: [],
        filesLoading: false,
        selectedFileDetails: null,
        updateFileTable: false,
        itemsPerPage: 10,
        nextPageMax: 5,
        pageNumber: 1,
        totalPages: 0,
        pageAddVisible: true,
        pageSubtractVisible: false,
        fileDetailsLoading: false,
        showCaseDetailsView: false,
        selectedCaseDetails: null,
      }

      updatedForm.pages.replaceFile = {
        ...updatedForm.pages.replaceFile,
        file: replaceFileData.file ? replaceFileData.file : fileData,
        imageFileName: replaceFileData.imageFileName ? replaceFileData.imageFileName : selectedCaseDetails.imageDetails.imageName,
        imageID: replaceFileData.imageID ? replaceFileData.imageID : Number(selectedCaseDetails.imageDetails.externalImageID),
      }
      if (selectedCaseDetails.illustrationType === 'PERM') {
        updatedForm.pages.selectProduct = {
          ...updatedForm.pages.selectProduct,
          category: 'PERM',
          recurringAnnualPremium: selectProductData.recurringAnnualPremium ? selectProductData.recurringAnnualPremium : selectedCaseDetails.faceAmount
        }
      }
      else if ((selectedCaseDetails.illustrationType === 'LTC')) {
        const isFromDropDown = (selectedCaseDetails.faceAmount <= 500000 || selectedCaseDetails.faceAmount >= 50000) && selectedCaseDetails.faceAmount % 50000 === 0
        updatedForm.pages.selectProduct = {
          ...updatedForm.pages.selectProduct,
          category: 'LTC',
          premium: selectProductData.premium ? selectProductData.premium : (isFromDropDown ? selectedCaseDetails.faceAmount : 'specificPremium'),
          specificPremium: selectProductData.specificPremium ? selectProductData.specificPremium : isFromDropDown ? '' : selectedCaseDetails.faceAmount
        }
      }
    }
    return updatedForm;
  }

  const [formState, setFormState] = useState(IllustrationRequest && IllustrationRequest.selectedCaseDetails ? getDataFromIllustration() : initialFormState);
  const isSurvivorshipPolicy = formState && formState.pages && formState.pages.retrieveAccount && formState.pages.retrieveAccount.insurancePolicyType === insurancePolicyTypes.SURVIVORSHIP;
  const showAttestation = formState && formState.pages.selectProduct.productCode === "SL16" && formState.pages.selectProduct.category === "PERM";
  const isPermCaseCreation = formState && formState.pages.selectProduct && formState.pages.selectProduct.category === "PERM";
  const isMSEnableCreateCaseSurvivorshipWorkflow = isDICreateCase ? false : (isPermCaseCreation ? isMSEnablePERMCreateCaseSurvivorshipWorkflow : isMSEnableABLTCCreateCaseSurvivorshipWorkflow);
  sessionStorage.removeItem(SELECTED_PRODUCT_FOR_SUBMIT_A_CASE);

  useEffect(() => {

    if (!path) {
      return;
    }

    let nextStep = steps.find((s) => s.path === path);

    if (!nextStep) {
      const newPath = props.location ? props.location.pathname.split("/").slice(-2) : null;
      if (!newPath) {
        return;
      }

      nextStep = steps.find((s) => s.path === newPath[0]);
      if (!nextStep) {
        return;
      }
    }
    const newFormState = { ...formState, currentStep: nextStep.step };
    setFormState(newFormState);
  }, [path]);

  const onNext = () => {
    let nextStep = 0;
    nextStep = steps.find((s) => s.step === formState.currentStep + 1);
    if (nextStep.path === 'Attestation' && !showAttestation) {
      nextStep = steps.find(s => s.step === nextStep.step + 1);
    }
    if (nextStep.path === 'QuoteSuccess' && (formState.pages.yourInformation.isQuoteFailure === true)) {
      nextStep = steps.find(s => s.step === nextStep.step + 1);
    }
    if (!nextStep) {
      throw new Error('onNext did not find a next step');
    }

    const newFormState = { ...formState, currentStep: nextStep.step };

    setFormState(newFormState);
    setSessionStorageItem(SESSION_STORAGE_CREATE_CASE, newFormState);

    props.history.push(`/Activity/NewCase/${nextStep.path}`);
    window.scroll(0, 0);
  };

  const onBack = () => {
    let backStep = steps.find(s => s.step === formState.currentStep - 1);
    if (backStep) {
    if (backStep.path === 'QuoteSuccess' && (formState.pages.yourInformation.isQuoteFailure === true)) {
      backStep = steps.find(s => s.step === backStep.step - 1);
    }
    if (backStep.path === 'Attestation' && !showAttestation) {
      backStep = steps.find(s => s.step === backStep.step - 1);
    }
      const newFormState = { ...formState, currentStep: backStep.step };

      setFormState(newFormState);
      setSessionStorageItem(SESSION_STORAGE_CREATE_CASE, newFormState);

      props.history.push(`/Activity/NewCase/${backStep.path}`);
      window.scroll(0, 0);

    } else {
      props.history.push(productObject ? productObject : '/Products');
      sessionStorage.removeItem(SESSION_STORAGE_CASE_RETURN_PATH);
    }
  };

  const onFieldChange = (step, field, value) => {
    setFormState({ ...formState, pages: { ...formState.pages, [step]: { ...formState.pages[step], [field]: value } } });
  }

  const setAllFormOnAccountNoChanged = (value = null, isSetPrefillData = false) => {
    let newFormState = formState;
    const clientData = isSetPrefillData ? newFormState.pages.retrieveAccount : Steps.RetrieveAccount.DefaultFormState(prefill, isMSEnableCreateCaseSurvivorshipWorkflow);
    const insuredData = isSetPrefillData ? newFormState.pages.insuredBasicInfo : Steps.InsuredBasicInfo.DefaultFormState(prefill);
    const esignData = Steps.ESign.DefaultFormState(prefill);
    if(IllustrationRequest && IllustrationRequest.selectedCaseDetails){
      clientData.isProposedInsured = (IllustrationRequest.selectedCaseDetails.piIsOwner && !IllustrationRequest.selectedCaseDetails.isSurvivorshipPolicyType) ? 'true' : 'false';
      insuredData.state = IllustrationRequest.selectedCaseDetails.state;
      insuredData.birthdate = IllustrationRequest.selectedCaseDetails.birthDate ? format(new Date(IllustrationRequest.selectedCaseDetails.birthDate), 'MM/dd/yyyy'):'';
      insuredData.gender = IllustrationRequest.selectedCaseDetails.gender === "F" ? 'F' :IllustrationRequest.selectedCaseDetails.gender ==='M' ? 'M' : '' ;
      insuredData.maritalStatus = IllustrationRequest.selectedCaseDetails.maritalStatus === 'Married' ? 'M' : 'S';
      insuredData.tobacco = IllustrationRequest.selectedCaseDetails.tobaccoUse?'true':'false';
      insuredData.PremiumAmount = IllustrationRequest.selectedCaseDetails.faceAmount;
      insuredData.proposedInsuredFirstName = IllustrationRequest.selectedCaseDetails.firstName;
      insuredData.proposedInsuredMiddleInitial = IllustrationRequest.selectedCaseDetails.middleName && IllustrationRequest.selectedCaseDetails.middleName.length > 0 ? IllustrationRequest.selectedCaseDetails.middleName.substring(0, 1) : '';
      insuredData.insuredRelationshipWithOwner = IllustrationRequest.selectedCaseDetails.insuredRelationshipWithOwner;
      insuredData.proposedInsuredLastName = IllustrationRequest.selectedCaseDetails.lastName;
      insuredData.proposedInsuredEmail = IllustrationRequest.selectedCaseDetails.email;
      insuredData.proposedInsuredPhone = GetFormattedNumber(IllustrationRequest.selectedCaseDetails.primaryPhone);
    }
    clientData.clientType = value || formState.pages.retrieveAccount.clientType;
    clientData.officeFa = formState.pages.retrieveAccount.officeFa;
    clientData.officeAccount = formState.pages.retrieveAccount.officeAccount;
    clientData.branchOptions = formState.pages.retrieveAccount.branchOptions;
    clientData.faNum = formState.pages.retrieveAccount.faNum;
    clientData.officeNum = formState.pages.retrieveAccount.officeNum;
    newFormState.pages.retrieveAccount = clientData;
    newFormState.pages.insuredBasicInfo = insuredData;
    newFormState.pages.esign = esignData;
    setFormState({ ...newFormState });
  }

  const calculatePercentage = (totalStep, step, categoryStep, currentCateTotalStep) => {
    let stepPer = ((step - 1) / totalStep * 100);
    let cateCount = currentCateTotalStep === 1 ? 1 : (((categoryStep - 0.5) / currentCateTotalStep) * (100 / totalStep));
    return (stepPer + cateCount);
  }

  // const calculateInsuredAge = () => {
  //   const birthdate = formState.pages.retrieveAccount &&
  //     (formState.pages.retrieveAccount.isProposedInsured === 'true' ?
  //     formState.pages.retrieveAccount.ownerDetails.dateOfBirth : formState.pages.insuredBasicInfo.birthdate);
  //
  //   if (birthdate) {
  //     return Age(birthdate);
  //   }
  // }

  const clearFormState = () => {
    let newForm = {...newFormState};
    const category = formState.pages.selectProduct.category;
    const isSelectedProduct = formState.pages.selectProduct.isSelectedProduct;
    if(isSelectedProduct){
      newForm.pages.selectProduct.category = category;
      newForm.pages.selectProduct.isSelectedProduct = isSelectedProduct;
    }
    sessionStorage.removeItem(SESSION_STORAGE_CREATE_CASE);
    sessionStorage.removeItem(ILLUSTRATION_PREFILL_DATA);
    setFormState(newForm);
    props.history.push('/Activity/NewCase/Client');
  }

  const steps = [
    {
      step: 1,
      path: 'Client',
      progressTitle: 'Basics',
      component: (
        <Steps.RetrieveAccount
          formState={formState.pages.retrieveAccount}
          onFieldChange={(field, value) => onFieldChange('retrieveAccount', field, value)}
          onNext={onNext}
          onBack={onBack}
          setAllFormOnAccountNoChanged={(value, isSetPrefillData)=> setAllFormOnAccountNoChanged(value, isSetPrefillData)}
          fullFormState={formState}
          hideClientTypeRadio={true}
          disableSurvivorshipDropDown={!isMSEnableCreateCaseSurvivorshipWorkflow}
          onMultiFieldChange={(fs) => {
            setFormState(fs);
          }}
          isSubmitCase={true}
          esignData = {Steps.ESign.DefaultFormState(prefill)}
          insuredInfoDefaultState = {Steps.InsuredBasicInfo.DefaultFormState(prefill)}
          isCopyCaseData = {isCopyCaseData}
        />
      ),
      breadCrumbTitle: 'NEW CASE',
      categoryNumber: 1,
      categoryStep: 1,
    },
    {
      step: 2,
      path: 'BasicInfo',
      progressTitle: 'Basics',
      component: (
        <Steps.InsuredBasicInfo
          formState={formState.pages.insuredBasicInfo}
          onFieldChange={(field, value) => onFieldChange('insuredBasicInfo', field, value)}
          onNext={onNext}
          onBack={onBack}
          fullFormState={formState}
          isSurvivorshipPolicy={isSurvivorshipPolicy}
          onMultiFieldChange={(fs) => {
            setFormState(fs);
          }}
          ageSpecs={formState.pages.selectProduct.category === "LTC" ? { min: 30, max: 80 } : { min: 0, max: 99 }}
        />
      ),
      breadCrumbTitle: 'NEW CASE',
      categoryNumber: 1,
      categoryStep: 2,
    },
    {
      step: 3,
      path: 'ProductInfo',
      progressTitle: 'Basics',
      component: (
        <Steps.SelectProduct
          formState={formState.pages.selectProduct}
          roleType={props.roleType}
          onFieldChange={(field, value) => onFieldChange('selectProduct', field, value)}
          onNext={onNext}
          onBack={onBack}
          fullFormState={formState}
          isSurvivorshipPolicy={isSurvivorshipPolicy}
          isMSEnablePERMCreateCaseSurvivorshipWorkflow={isMSEnablePERMCreateCaseSurvivorshipWorkflow}
          isMSEnableABLTCCreateCaseSurvivorshipWorkflow={isMSEnableABLTCCreateCaseSurvivorshipWorkflow}
          isDICreateCase={isDICreateCase}
          onMultiFieldChange={(fs) => {
            setFormState(fs);
          }}
          insuredAge={35} // replace
          residentState={formState.pages.insuredBasicInfo.state || 'CA'} // need to update to use selected owner state if available
        />
      ),
      breadCrumbTitle: 'NEW CASE',
      categoryNumber: 1,
      categoryStep: 2,
    },
    {
      step: 4,
      path: 'Attestation',
      progressTitle: 'Basics',
      component: (
        <Steps.Attestation
          formState={formState.pages.attestation}
          quoterState={formState.pages.selectProduct}
          showAttestation={showAttestation}
          onFieldChange={(field, value) => onFieldChange('attestation', field, value)}
          onNext={onNext}
          onBack={onBack}
        />
      ),
      breadCrumbTitle: 'NEW CASE',
      categoryNumber: 2,
      categoryStep: 2,
    },
    {
      step: 5,
      path: 'FileUpload',
      progressTitle: 'Product Information',
      component: (
        <Steps.ReplaceFile
          IllustrationRequest={IllustrationRequest && IllustrationRequest.selectedCaseDetails}
          formState={formState.pages.replaceFile}
          onFieldChange={(field, value) => onFieldChange('replaceFile', field, value)}
          onNext={onNext}
          onBack={onBack}
          onMultiFieldChange={(fs) => {
            setFormState(fs);
          }}
          fullFormState={formState}
        />
      ),
      breadCrumbTitle: 'NEW CASE',
      categoryNumber: 2,
      categoryStep: 3,
    },
    {
      step: 6,
      path: 'ApplicationInfo',
      progressTitle: 'Basics',
      component: (
        <Steps.ApplicationInformation
          formState={formState.pages.applicationInformation}
          onFieldChange={(field, value) => onFieldChange('applicationInformation', field, value)}
          onNext={onNext}
          onBack={onBack}
          onMultiFieldChange={(fs) => {
            setFormState(fs);
          }}
          fullFormState={formState}
          isTerm = {false}
        />
      ),
      breadCrumbTitle: 'NEW CASE',
      categoryNumber: 1,
      categoryStep: 4,
    },
    {
      step: 7,
      path: 'ESign',
      progressTitle: 'Basics',
      component: (
        <Steps.ESign
          formState={formState.pages.esign}
          onFieldChange={(field, value) => onFieldChange('esign', field, value)}
          onNext={onNext}
          onBack={onBack}
          fullFormState={formState}
          onMultiFieldChange={(fs) => {
            setFormState(fs);
          }}
        />
      ),
      breadCrumbTitle: 'QUOTE',
      categoryNumber: 3,
      categoryStep: 5,
    },
    {
      step: 8,
      path: 'YourInformation',
      progressTitle: 'Basics',
      component: (
        <Steps.YourInformation
          formState={formState.pages.yourInformation}
          basicInfo={formState}
          onFieldChange={(field, value) => onFieldChange('yourInformation', field, value)}
          onNext={onNext}
          onBack={onBack}
          showAttestation={showAttestation}
          isSurvivorshipPolicy={isSurvivorshipPolicy}
          productType={'SUBMIT_ILLUSTRATION'}
          isSubmitCase={true}
          isDICreateCase={isDICreateCase}
          onMultiFieldChange={(fs) => {
            setFormState(fs);
          }}
        />
      ),
      breadCrumbTitle: '',
      categoryNumber: 4,
      categoryStep: 1,
    },
    {
      step: 9,
      path: 'QuoteSuccess',
      progressTitle: 'Basics',
      component: (
        <Steps.QuoteSuccess
          formState={formState.pages.quoteSuccess}
          onFieldChange={(field, value) => onFieldChange('quoteSuccess', field, value)}
          onNext={onNext}
          onBack={onBack}
          yourInformation={formState.pages.yourInformation}
          clearFormState={clearFormState}
        />
      ),
      breadCrumbTitle: 'QUOTE',
      categoryNumber: 4,
      lastStep: true,
    },
    {
      step: 10,
      path: 'QuoteFailure',
      progressTitle: 'Basics',
      component: (
        <Steps.QuoteFailure
          formState={formState.pages.quoteFailure}
          onFieldChange={(field, value) => onFieldChange('quoteFailure', field, value)}
          onNext={onNext}
          onBack={onBack}
          yourInformation={formState.pages.yourInformation}
          clearFormState={clearFormState}
        />
      ),
      breadCrumbTitle: 'QUOTE',
      categoryNumber: 4,
      lastStep: true,
    },
  ];

  const currentStepObj = steps.find(s => s.step === formState.currentStep) || steps[0];
  const categories = steps.filter((o) => o.categoryNumber === currentStepObj.categoryNumber);
  const totalCategoriesStep = Math.max.apply(Math, categories.map(function (o) {
    return o.categoryStep;
  }))

  const percent = calculatePercentage(4, currentStepObj.categoryNumber, currentStepObj.categoryStep, totalCategoriesStep);
  return (
    <div>
      <Helmet>
        <title>Covr Advisor - {currentStepObj.progressTitle} </title>
      </Helmet>

      <HeaderProgressTracker breadCrumb={currentStepObj.breadCrumbTitle}
        breadcrumbLink={[{ name: 'PRODUCTS', href: '/Products' },{ name: 'CREATE CASE', href: `${productObject || "/Products"}` }]}
        headerProductsText={true} displayStepTitleWithArrow={true} currentPage={true}
        showContainer={false} hideProgressTracker={currentStepObj.hideProgressTracker}
        title="Create Case" stepName={currentStepObj.progressTitle}
        step={currentStepObj.categoryNumber} categoryStep={currentStepObj.categoryStep}
        path={currentStepObj.path} totalSteps={4} lastStep={currentStepObj.lastStep}
        percent={percent} hidePadding={currentStepObj.path !== 'request-summary' ? false : true}
        hidden={currentStepObj.hideMainHeader}>
        <div className="CreateCase">
          {currentStepObj.component}
        </div>
      </HeaderProgressTracker>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Product/CreateCase/CreateCase.js